export default "__VITE_ASSET__CkwytFv5__"